import { whooshPrimitives } from "./primitives";

export type WhooshTextColorTokens = {
  "text-primary": string;
  "text-secondary": string;
  "text-disabled": string;
  "text-inverse": string;
  "text-main-primary": string;
  "text-main-primary-inverse": string;
  "text-main-secondary": string;
  "text-main-secondary-inverse": string;
  "text-accent-blue-primary": string;
  "text-accent-blue-inverse": string;
  "text-accent-purple-primary": string;
  "text-accent-purple-inverse": string;
  "text-accent-pink-primary": string;
  "text-accent-pink-inverse": string;
  "text-success": string;
  "text-success-inverse": string;
  "text-warning": string;
  "text-warning-inverse": string;
  "text-error": string;
  "text-error-inverse": string;
};

export const whooshTextColors: WhooshTextColorTokens = {
  "text-primary": whooshPrimitives.grayscale[1000],
  "text-secondary": whooshPrimitives.grayscale[900],
  "text-disabled": whooshPrimitives.grayscale[900],
  "text-inverse": whooshPrimitives.grayscale[0],
  "text-main-primary": whooshPrimitives.main.primary[700],
  "text-main-primary-inverse": whooshPrimitives.main.primary[1000],
  "text-main-secondary": whooshPrimitives.main.secondary[500],
  "text-main-secondary-inverse": whooshPrimitives.main.secondary[1000],
  "text-accent-blue-primary": whooshPrimitives.accent.blue[600],
  "text-accent-blue-inverse": whooshPrimitives.accent.blue[1000],
  "text-accent-purple-primary": whooshPrimitives.accent.purple[600],
  "text-accent-purple-inverse": whooshPrimitives.accent.purple[1000],
  "text-accent-pink-primary": whooshPrimitives.accent.pink[600],
  "text-accent-pink-inverse": whooshPrimitives.accent.pink[1000],

  "text-success": whooshPrimitives.status.success[500],
  "text-success-inverse": whooshPrimitives.status.success[1000],
  "text-warning": whooshPrimitives.status.warning[500],
  "text-warning-inverse": whooshPrimitives.status.warning[1000],
  "text-error": whooshPrimitives.status.error[700],
  "text-error-inverse": whooshPrimitives.status.error[1000],
};
